import { Modal, Button, Form } from "react-bootstrap";
import { useEffect, useState } from "react";

export const CrearUbicacionModal = ({ show, onClose, onSave, }) => {

    const [errors, setErrors] = useState({});

    const validateForm = () => {
        const newErrors = {};


        if (!form.codigoUbicacion.trim()) {
            newErrors.codigoUbicacion = 'Debe ingresar el código de la ubicación';
        }

        if (!form.nombreUbicacion.trim()) {
            newErrors.nombreUbicacion = 'Debe ingresar el nombre del ubicación';
        }

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };


    // const [ ubicaciones, setUbicaciones ] = useState([]); 

    const [form, setForm] = useState({
        ideUbicacion: '',
        codigoUbicacion: '',
        nombreUbicacion: ''
    });

    const resetForm = () => {
        setForm({
            ideUbicacion: '',
            codigoUbicacion: '',
            nombreUbicacion: ''
        });
    };


    useEffect(() => {
        if (!show) {
            resetForm();
        }
    }, [show]);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;

        setForm(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));

        setErrors(prev => ({
            ...prev,
            [name]: ''
        }));
    };


    const handleSubmit = () => {

        if (!validateForm()) return;

        console.log(form);

        onSave({ ...form });
        // setModulo("");
    };

    return (
        <Modal show={show} onHide={onClose} centered size="lg">

            <Modal.Header closeButton className="border-0 pb-0">
                <Modal.Title className="fw-bold fs-4">Crear Ubicación / Sede </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <Form>

                    <Form.Group>
                        <Form.Label>Código Ubicación / Sede </Form.Label>
                        <Form.Control
                            name="codigoUbicacion"
                            value={form.codigoUbicacion}
                            onChange={handleChange}
                            placeholder="Ej: Caja 1"
                            isInvalid={!!errors.codigoUbicacion}

                        />
                    </Form.Group>
                    <Form.Control.Feedback type="invalid">
                        {errors.codigoUbicacion}
                    </Form.Control.Feedback>

                    <Form.Group>
                        <Form.Label>Ubicación / Sede </Form.Label>
                        <Form.Control
                            name="nombreUbicacion"
                            value={form.nombreUbicacion}
                            onChange={handleChange}
                            placeholder="Ej: Sede Principal"
                            isInvalid={!!errors.nombreUbicacion}

                        />
                    </Form.Group>
                    <Form.Control.Feedback type="invalid">
                        {errors.nombreUbicacion}
                    </Form.Control.Feedback>


                </Form>
            </Modal.Body>

            <Modal.Footer className="border-0 pt-0">
                <Button variant="light" onClick={onClose}>
                    Cancelar
                </Button>

                <Button variant="primary" onClick={handleSubmit}>
                    Guardar
                </Button>
            </Modal.Footer>

        </Modal>
    );
};